<template>
  <div class="home-content">
    <div class="title-section">
      <div class="title-text">
        <div class="title-label">
          ELI (Empower Language Intelligence)
        </div>
        <div class="title-description">
          ELI จะช่วยให้ Product ของคุณเข้าใจภาษาของมนุษย์ ด้วยการนำเอาเทคโนโลยี NLP เข้ามาใช้งาน<br>
          <!-- ทุก Service ที่ให้บริการถูกสร้างด้วยเทคโนโลยีสมัยใหม่และมาจาก Dataset ขนาดใหญ่<br> -->
          สามารถเรียกใช้งานได้ง่ายผ่าน RESTful API
        </div>
<!--        <router-link-->
<!--            to="/getstart"-->
<!--            exact-->
<!--        >-->
<!--          <button-->
<!--              class="title-button btn btn-primary"-->
<!--              @click="trackCustomEvent({ action: 'clicked', target: 'get_started_home_page', linkTo: 'getstart' })"-->
<!--          >-->
<!--            เริ่มต้นใช้งาน-->
<!--          </button>-->
<!--        </router-link>-->
      </div>
    </div>
    <div class="content-section">
      <b-container>
        <b-row>
          <div class="service-section">
            <div class="our-service-label">
              บริการของเรา
            </div>
            <b-container class="serivces" default>
              <b-row align-h="center">
                <b-col xl="4" lg="4" md="12" sd="12" xs="12">
                  <IconCard
                    icon="/assets/images/our_services_01.svg"
                    title="เทคโนโลยีใหม่สมัยใหม่และฐานข้อมูลขนาดใหญ่"
                    description="ทุกบริการถูกพัฒนาด้วยเทคโนโลสมัยใหม่ Train ด้วยฐานข้อมูลขนาดใหญ่ครอบคลุมการใช้งานที่หลากหลาย"
                  />
                </b-col>
                <b-col xl="4" lg="4" md="12" sd="12" xs="12">
                  <IconCard
                    icon="/assets/images/our_services_02.svg"
                    title="เชื่อมต่อง่ายๆ ด้วย RESTful API พร้อมเครื่องมือสำหรับบริหารจัดการด้วยตนเอง"
                    description="ทุกบริการเรียกใช้งานด้วย RESTful API และมี Console เพื่อให้เข้าไป Monitor และจัดการ Quota"
                  />
                </b-col>
                <b-col xl="4" lg="4" md="12" sd="12" xs="12">
                  <IconCard
                    icon="/assets/images/our_services_03.svg"
                    title="รองรับภาษาไทยและระบบจะเรียนรู้จาก Feedback ใหม่ๆ ตลอดเวลา"
                    description="ทุกบริการรองรับภาษาไทย และ Feedback จากการใช้งานจะถูกนำมาประมวลผลเพื่อพัฒนาบริการ"
                  />
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-row>
        <b-row>
          <OCRCard class="ocr-section" />
        </b-row>
        <b-row>
          <SentimentCard class="sentiment-section" />
        </b-row>
        <b-row>
          <ClassificationCard class="classification-section" />
        </b-row>
        <b-row>
          <ClusteringCard class="clustering-section" />
        </b-row>
        <b-row>
          <NLPServiceCard class="nlp-service-section" />
        </b-row>
      </b-container>
    </div>
    <div class="register-section">
<!--      <div class="register-title">-->
<!--        เริ่มต้นใช้งาน ELI-->
<!--      </div>-->
<!--      <router-link-->
<!--        to="/getstart"-->
<!--        exact-->
<!--      >-->
<!--        <button-->
<!--          class="register-button"-->
<!--          @click="trackCustomEvent({ action: 'clicked', target: 'get_started_home_page', linkTo: 'getstart' })"-->
<!--        >-->
<!--          เริ่มต้นใช้งาน-->
<!--        </button>-->
<!--      </router-link>-->
    </div>
    <div class="about-section">
      <b-row>
        <b-col class="about-col" xl="3" lg="6" md="6" sd="6" xs="6">
          <div class="about-title">
            About
          </div>
          <div class="about-text">
            ELI หรือ Empower Language Intelligence เป็นแหล่งรวม RESTful service สำหรับการใช้งาน NLP โดยมีตั้งแต่ NLP พื้นฐานจนไปถึง NLP ขั้นสูง และบริการ customize service ตามความต้องการของลูกค้า
          </div>
        </b-col>
        <b-col class="about-col" xl="3" lg="6" md="6" sd="6" xs="6">
          <div class="about-title">
            Quick Links
          </div>
          <div class="link">
<!--            <a-->
<!--              href="https://console.nlp.insightera.co.th"-->
<!--              class="kt-link kt-font-primary"-->
<!--              target="_blank"-->
<!--              @click="trackCustomEvent({ action: 'clicked', target: 'quick_links_home_page', linkTo: 'console' })"-->
<!--            >-->
<!--              Console-->
<!--            </a>-->
<!--            <a-->
<!--              href="https://console.nlp.insightera.co.th"-->
<!--              class="kt-link kt-font-primary"-->
<!--              target="_blank"-->
<!--              @click="trackCustomEvent({ action: 'clicked', target: 'quick_links_home_page', linkTo: 'docs' })"-->
<!--            >-->
<!--              API Document-->
<!--            </a>-->
            <a
              href="https://console.nlp.insightera.co.th"
              class="kt-link kt-font-primary"
              target="_blank"
              @click="trackCustomEvent({ action: 'clicked', target: 'quick_links_home_page', linkTo: 'insightera' })"
            >
              Insightera Co., Ltd.
            </a>
            <!-- <router-link
              to="/demo/ocr"
              class="kt-link kt-font-primary"
              exact
              tag="a"
            >
              Image Processing Services
            </router-link> -->
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BContainer, BCol, BRow } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import IconCard from '../components/home/IconCard'
import OCRCard from '../components/home/OCRCard'
import SentimentCard from '../components/home/SentimentCard'
import ClassificationCard from '../components/home/ClassificationCard'
import ClusteringCard from '../components/home/ClusteringCard'
import NLPServiceCard from '../components/home/NLPServiceCard'

export default {
  name: 'Home',
  components: {
    BContainer,
    BRow,
    BCol,
    IconCard,
    OCRCard,
    SentimentCard,
    ClassificationCard,
    ClusteringCard,
    NLPServiceCard
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    })
  }
}
</script>

<style scoped>
    body {
        background-color: #F7F8F9;
    }

    .home-content {
        font-family: Prompt, Serif;
    }

    .title-section {
        display: flex;
        height: 700px;
        align-items: center;
        background: #FFFFFF 0 0 no-repeat padding-box;
        background-image: url('/assets/images/header_full.svg');
        background-repeat: no-repeat;
        background-size: auto 654px;
        background-position: bottom right;
    }

    .content-section {
        background-image: url('/assets/images/background.svg');
        background-repeat: repeat-y;
        background-size: 2293px auto;
        background-position-x: center;
        background-position-y: -700px;
    }

    @media (max-width: 1023px) {
        .content-section {
            background-size: 1105px auto;
            background-position-x: center;
            background-position-y: -200px;
        }
    }

    @media (max-width: 767px) {
        .content-section {
            background-size: 1105px auto;
            background-position-x: center;
            background-position-y: -150px;
        }
    }

    @media (max-width: 1379px) {
        .title-section {
            background-image: url('/assets/images/header_small.svg');
        }
    }

    .title-text {
        margin-left: 10%;
        margin-right: 10%;
        width: 580px;
        display: flex;
        flex-direction: column;
    }

    .title-label {
        text-align: left;
        font-size: 32px;
        letter-spacing: 0;
        color: #48465B;
        opacity: 1;
    }

    .title-description {
        margin-top: 24px;
        margin-bottom: 24px;
        font-size: 14px;
        letter-spacing: 0;
        color: #9392A0;
        opacity: 1;
    }

    .service-section {
        /*height: 1006px;*/
        position: relative;
        /*background: #8C72FF 0% 0% no-repeat padding-box;*/
        overflow: hidden;
        opacity: 1;
        /*background-image: url('/assets/images/background_top.svg');*/
        /*background-size: 150% 200%;*/
        /*background-repeat: no-repeat;*/
        /*background-position: top;*/
        /*background-position-y: 100%;*/
        margin-bottom: 60px;
    }

    @media (max-width: 1025px) {
        [class*="col-"] {
            margin-bottom: 15px;
        }
    }

    [class*="about-col col-"] {
      margin-bottom: 30px;
    }

    .title-button {
        width: 145px;
        height: 54px;
    }

    .our-service-label {
        margin-top: 70px;
        margin-bottom: 50px;
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        letter-spacing: 0px;
        color: #FFFFFF;
        opacity: 1;
    }

    .ocr-section {
        margin-bottom: 63px;
    }

    .sentiment-section {
        margin-bottom: 63px;
    }

    .classification-section {
        margin-bottom: 63px;
    }

    .clustering-section {
        margin-bottom: 63px;
    }

    .nlp-service-section {
        margin-bottom: 63px;
    }

  .register-section{
    flex-direction: column;
    height: 253px;
    background: transparent linear-gradient(106deg, #6F4FFF 0%, #6F4FFFC0 67%, #6F4FFF59 100%) 0% 0% no-repeat padding-box;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .register-title{
    text-align: center;
    color: #FFFFFF;
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 22px;
  }

  .register-button{
    width: 145px;
    height: 54px;
    color: #6F4FFF;
    font-size: 16px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid white !important;
    border-radius: 4px;
    opacity: 1;
  }

  .about-section{
    min-height: 250px;
    background: #282A3C 0% 0% no-repeat padding-box;
    padding: 42px 140px;
  }

  .about-title{
    font-size: 26px;
    color: white;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .about-text{
    text-align: left;
    font-size: 14px;
    color: white;
  }

  .link{
    display: flex;
    flex-direction: column;
  }

  .kt-link{
    background-color: transparent;
    border: transparent;
    width: fit-content;
    color: white !important;
    padding: 0;
    margin: 0 0 15px;
  }
</style>
